<template>
  <PerformsAreaReportComponent
      :items="items"
      :filters="$route.params.filters"
      :region-id="$route.params.regionId"
      @updated="onUpdate"
  />
</template>

<script>

import _ from "underscore"
import Moment from "moment";
import Mapper from "@/mappers"
import {AllowPerformStatistics} from "@/enums/permission";
import ReportService from "@/services/report.service"
import {  LAYOUT_LOADING_START,  LAYOUT_LOADING_STOP,  LAYOUT_TITLE_CHANGED} from "@/store/modules/layout/actions";
import PerformsAreaReportComponent from "@/components/report/DeliveryStatistics/PerformsAreaReportComponent.vue";

export default {
  name: "AreaPerformsReportView",
  components: {
    PerformsAreaReportComponent
  },
  data() {
    return {
      items: []
    }
  },
  computed: {
    isAllowStatistics() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowPerformStatistics
      })
    }
  },
  methods: {
    onUpdate(filters) {
      let regionId = this.$route.params.regionId;
      const {start, end, date, selectedFilters, selectedAreas, isAllClientsSelected, isArchive, clients} = filters;

      this.$store.dispatch(LAYOUT_LOADING_START)
      ReportService.getPerformAreaReport({
        client: this.$store.getters.appActiveClient,
        start: start ? Moment(start, "YYYY-MM-DD") : null,
        end: end ? Moment(end, "YYYY-MM-DD") : null,
        date: date ? Moment(date, "YYYY-MM") : null,
        regionId : regionId,
        selectedFilters: selectedFilters ? selectedFilters : null,
        selectedAreas: selectedAreas ? selectedAreas : null,
        isAllClientsSelected: isAllClientsSelected,
        type: isArchive,
        clients: clients
      })
          .then(response => {
            this.items = _.map(response.data, rvm => {
              return {
                area: Mapper.mapArea(rvm.Area),
                received: rvm.Received,
                successDelivered: rvm.SuccessDelivered,
                receiverDead: rvm.ReceiverDead,
                receiverNotLivesThere: rvm.ReceiverNotLivesThere,
                incompleteAddress: rvm.IncompleteAddress,
                receiverRefuse: rvm.ReceiverRefuse,
                notAtHome: rvm.NotAtHome,
                didntAppearOnNotice: rvm.DidntAppearOnNotice,
                defect: rvm.Defect,
                tryPerform: rvm.TryPerform,
                organizationWithGivenAddressNotFound: rvm.OrganizationWithGivenAddressNotFound,
                rest: rvm.Received - (rvm.SuccessDelivered + rvm.ReceiverDead +
                    rvm.ReceiverNotLivesThere + rvm.IncompleteAddress +
                    rvm.ReceiverRefuse + rvm.NotAtHome + rvm.DidntAppearOnNotice +
                    rvm.Defect + rvm.TryPerform + rvm.OrganizationWithGivenAddressNotFound)
              }
            })
          })
          .finally(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    }
  },
  created() {
    if (this.isAllowStatistics) {
      this.$store.dispatch(LAYOUT_TITLE_CHANGED, "Статистика о статусе")
    }
    else
      this.$router.go(-1)
  }
}
</script>

<style scoped>
</style>
